module.exports = __webpack_public_path__ + "img/submit-button.c762ab3b.png";